import MerchandisingModal from './MerchandisingModal';

export default MerchandisingModal;
